import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { AccessService } from '../../Accesses/shared/access.service'
import { RolAccessService } from '../shared/rolAccess.service'
import { rolAccess, IrolAccess } from '../shared/rolAccess.model'

@Component({
  selector: 'app-rolAccess',
  templateUrl: 'rolAccess.component.html',
})

export class RolAccessComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  @Input() ID: number;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] = ['indCheck', 'ID', 'AplicacionName', 'RoleName', 'AplicacionID', 'RoleID', 'Name', 'Path', 'Descripcion', 'Status'];
  dataSource: GridDataSource; //MatTableDataSource<Iaplicacion>;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;
  rolAccess: IrolAccess;

  constructor(private loaderService: LoaderService,
    private accessService: AccessService,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private rolAccessService: RolAccessService,
    private utilityService: UtilityService) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.titlePage = 'Aplicacion';
    this.msgErrorGet = 'Error al listar los Roles / Accesos';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
    this.buscarAccess("");
  }

  handleRowClick(row: any, event: any, rowNum: number) {
    this.selectedRowIndex = row.rownum;
    this.data.aplicacion = { codVersion: row.codVersion };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarAccess(data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    this.listarAccess(this.sectionBarComponent.filtro);
  }

  buscarAccess(filtro: string) {
    this.clearMatPaginator();
    this.listarAccess(filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarAccess(filtro: string): void {
    // this.loaderService.show();
    // this.accessService.listarAccess(filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
    // .subscribe(res => {
    //   if (this.errorService.getMessageError(res)) {
    //     this.dataSource = new GridDataSource(res); //new GridDataSource(res);
    //     this.showHideMessageGridEmpty(Number(res.length));
    //     this.pageEvent.length = res.length;
    //     this.setMatPaginator();
    //   }
    // },
    // error => {
    //   this.notificationService.error(this.msgErrorGet);
    //   throw error;
    // },
    // () => {
    //   this.loaderService.hide();
    // });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }

  onChangeVinculacion(event: any, row: any) {
    let RoleID: number;
    if (event.checked)
      RoleID = 1;
    else
      RoleID = row.RoleID
    this.toggleRolAccess(row.ID, row.AplicacionID, 1, event.checked)
  }

  private toggleRolAccess(AccessID: number, AplicacionID: number, RoleID: number, pToggle: boolean): void {
    this.loaderService.show();
    this.rolAccessService.toggleRolAccess(AccessID, RoleID, AplicacionID, pToggle)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          // this.notificationService.showMessage(this.msgErrorToggleVincularCorreoAfiliado, TYPEMESSAGE.Error);
          throw error;
        },
        () => {
          this.loaderService.hide();
          // this.listarCorreosAfiliado(this.data.codAfiliado);
        });
  }

}


